import SelectFilter from '../templates/SelectFilter';
import { MODALITIES } from '@vindr/services/constants/study.constant';
import { useMemo } from 'react';

const Modality = ({ value, title, placeholder, onChange, width = 200, mode }: SelectFilter) => {
  const options = useMemo(
    () => MODALITIES.map((modality) => ({ value: modality, label: modality })),
    []
  );

  return (
    <SelectFilter
      {...{ width, options, mode, value, title, placeholder, onChange }}
      searchVietnamese
    />
  );
};

export default Modality;
